import posthog from 'posthog-js';

const POSTHOG_KEY =
  process.env.REACT_APP_POSTHOG_KEY || 'phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs';

/**
 * PostHog solo por proxy /phk (mismo origen). Sin iframes externos ni CDN us-assets.
 * REACT_APP_POSTHOG_ENABLED=false en build → no carga analytics (útil para escaneos).
 */
export function initPostHog() {
  if (process.env.REACT_APP_POSTHOG_ENABLED === 'false') return;
  if (!POSTHOG_KEY || typeof window === 'undefined') return;

  const useProxy = process.env.NODE_ENV === 'production';

  posthog.init(POSTHOG_KEY, {
    api_host: useProxy ? `${window.location.origin}/phk` : 'https://us.i.posthog.com',
    ui_host: 'https://us.posthog.com',
    person_profiles: 'identified_only',
    disable_session_recording: true,
    session_recording: {
      recordCrossOriginIframes: false,
      capturePerformance: false,
    },
  });
}

export { posthog };
